
import {GoingUtils} from "goingutils";
class GoToolTipCtl {

    constructor({parent, msg, targetElId}) {
        if (parent != null) {
            if (parent != null && parent.get != null) {
                parent = parent.get(0);
            }
            this._targetElId = targetElId;
            this.createToolTip(msg);
            this.show(parent);
        }
    }

    createToolTip(msg) {
        //新增tooltip提醒信息
        $(
            '<div class="tooltip fade top in" role="tooltip" id="' +
            this._targetElId +
            '_toolTip">' +
            '<div class="tooltip-arrow" style="left: 50%;"></div>' +
            '<div class="tooltip-inner">' +
            msg +
            "</div></div>"
        ).appendTo($("#main_router_view"));
    }

    show(targetEl) {
        let maxZIndex = GoingUtils.getCurMaxZIndex();
        //如果存在窗口 则需要获取更大的zIndex
        if ($(".layui-layer").length > 0) {
            maxZIndex =
                parseFloat(
                    $($(".layui-layer").get($(".layui-layer").length - 1)).css("zIndex")
                ) + 1;
        }
        //计算提示的位置
        if (targetEl != null) {
            let {x, y} = GoingUtils.getElementPosition(targetEl);
            let height = $("#" + this._targetElId + "_toolTip").height();
            let elWidth = $("#" + this._targetElId + "_toolTip").css("width");
            $("#" + this._targetElId + "_toolTip")
                .css("top", parseFloat(y) - parseFloat(height + ""))
                .css("left", parseFloat(x) - parseFloat(elWidth) / 2 + 9)
                .css("zIndex", maxZIndex)
                .show();
        }
    }
}

export default GoToolTipCtl;



// WEBPACK FOOTER //
// ./goingsrc/jsCom/comCtl/goToolTipCtl.js